<template>
  <div>
    <section class="section">
      <div class="container">
        <div class="columns is-centered is-multiline">
          <div class="column is-3">
            <figure class="image">
              <img src="@/assets/img/logo.png">
            </figure>
          </div>
          <div class="column is-12"></div>
          <div class="column is-6">
            <b-notification type="is-primary" has-icon icon-pack="mdi">
              <strong>Redirección</strong>
              <br>Está saliendo de Mundo Fotográfico. Aguarde un instante mientras es redirigido a <small><strong>{{url}}</strong></small>
            </b-notification>
            <progress class="progress is-primary" max="100"></progress>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { setTimeout } from 'timers'
export default {
  name: 'Redirect',
  props: ['url', 'tiempoEspera'],
  mounted () {
    const vueComponent = this
    setTimeout(() => {
      window.location = vueComponent.url
    }, this.tiempoEspera)
  }
}
</script>
